<template>
    <div class="div-botao">
        <button class="buttonAvancar" :style="botaoPreenchimento">
            <div v-if="permiteEscolherMenosItens&&!itensRespondidos">
                <span>Não, Obrigado!</span>
            </div>
            <div class="botao" v-else>
                <img class="icon-check" src="../../assets/icons/ic-check.png" alt="">
                <span>Avançar</span>
            </div>
            <!-- <p v-if="!permiteEscolherMenosItens" class="txt-qtd">Itens selecionados {{ itensRespondidos.toString() }}/{{  itensNaEtapa.toString() }}</p> -->
            <div class="" v-if="jaEscolheuTodosItens">
                <p class="txt-itens" style="font-weight: bold; background: rgba(0,0,0,0.5)" v-if="!perguntasObrigatoriasRepondidas">Por favor, responda todos os tópicos obrigatórios.</p>
            </div>
        </button>
    </div>

</template>

<script>

export default {
    name: 'EtapasBotaoAvancar',
    props: {
        itensNaEtapa: Number,
        itensRespondidos: Number,
        perguntasObrigatoriasRepondidas: Boolean,
        permiteEscolherMenosItens: Boolean,
        isPrimeiraEtapa: Boolean,
    },
    data() {
        return {
        }
    },
    // 15 30 25 50
    computed: {
        percentage() {
            if (this.permiteEscolherMenosItens) {
                if (this.isPrimeiraEtapa) {
                    if (this.itensRespondidos > 0) {
                        return 100
                    } else {
                        return 0 
                    }
                } else {
                    return 100
               
                }
            } else {
                let perc = (this.itensRespondidos  / this.itensNaEtapa) * 100
                return perc
            }
        },
        botaoPreenchimento() {
            return {
                background: `linear-gradient(to right, var(--valor-verde) ${this.percentage}%, var(--cinza-escuro) ${this.percentage}%)`,
            };
        },
        jaEscolheuTodosItens(){
            if (this.itensRespondidos == this.itensNaEtapa) return true
            return false 
        },

    },
}
</script>

<style scoped>
.div-botao{
    bottom: 0px;
}
.buttonAvancar{
    width: 100%;
    color: white;
    height: 60px;
    border-radius: 5px;
    font-size: 1.4em;
    font-weight: bold;
}
.preenchimento {
    border-radius: 10px;
    position: absolute;
    top: 6px;
    left: 6px;
    background: linear-gradient(to bottom, green, #2F4538);
    z-index: 1;
}
.txt-itens {
    z-index: 5;
    margin: 0;
    font-size: 0.6em;
    font-weight: 500;
}
.txt-qtd{
    font-size: 0.8em;
    font-weight: 500;
}
.botao{
    width: 100%;
    height: 50px;
    border-radius: 5px;
    font-weight: bold;
    display:flex;
    align-items: center;
    justify-content: center;
}
.icon-check{
    height: 25px;
    width: 25px;
    left: 10%;
    filter: invert(100%);
    position: absolute;
}
</style>